import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

interface SiderContextInterface {
  isSiderCollapsed: boolean;
  setIsSiderCollapsed: Dispatch<SetStateAction<boolean>>;
}

const defaultSiderContext: SiderContextInterface = {
  isSiderCollapsed: false,
  setIsSiderCollapsed: () => {},
};

const SiderContext = createContext<SiderContextInterface>(defaultSiderContext);

interface SiderProviderProps {
  children: React.ReactNode;
}

export const SiderProvider: React.FC<SiderProviderProps> = ({ children }): JSX.Element => {
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(false);

  const value: SiderContextInterface = {
    isSiderCollapsed,
    setIsSiderCollapsed,
  };

  return <SiderContext.Provider value={Object.freeze(value)}>{children}</SiderContext.Provider>;
};

export const useSiderContext = (): SiderContextInterface => useContext(SiderContext);
